import React from 'react';
import { connect } from 'react-redux';
import { TrackingState } from './reducer';
import { thunkLoadTracking } from './actions';
import { thunkPushEvent } from '../events/actions';

import TrackingWrapper from './TrackingWrapper';
import Loading from '../static/loading';
import { Legal } from '../static/legal';
import { withCookies, Cookies } from 'react-cookie';
import { Completed } from '../static/completed';
import queryString from 'query-string';
import { withTranslation } from 'react-i18next';
import { EventType } from '../events/entities';
import { StyleSheetManager } from 'styled-components';
import rtlPlugin from 'stylis-plugin-rtl';
import { FinalStatuses, NOT_FOUND_ERR } from './entities';
import { includes } from 'lodash';
const rtlLanguages = ['he'];

interface State {
    token: string;
    locale: string;
    legalApproved: boolean;
}

interface Props {
    thunkLoadTracking: any;
    thunkPushEvent: any;
    tracking: TrackingState;
    cookies: Cookies;
    location: any;
    i18n: any;
}

class Tracking extends React.Component<Props, State> {
    interval: NodeJS.Timeout | undefined;

    constructor(props: Props) {
        super(props);

        let locale = 'en';
        const { cookies } = props;

        const values = queryString.parse(this.props.location.search);

        if (values.lc) {
            this.props.i18n.changeLanguage(values.lc);
            locale = values.lc.toString();
            this.setPageDirection(locale);
        }

        var urlParams = new URLSearchParams(window.location.search);
        var parsedToken = urlParams.get('token');

        var token = '';
        if (parsedToken != null && parsedToken !== '') {
            token = parsedToken;
            this.props.thunkPushEvent(token, EventType.EVENT_TYPE_LINK_OPENED);
        }
        const cookiesToken = cookies.get(token);
        const legalApproved = token === '' ? false : !!cookiesToken;
        this.state = {
            token: token,
            locale: locale,
            legalApproved: legalApproved,
        };
    }

    componentDidMount() {
        this.props.thunkPushEvent(this.state.token, EventType.EVENT_TYPE_PAGE_LOADED);
        if (this.state.legalApproved) {
            this.startPolling();
        }
    }

    setPageDirection(language) {
        const dir = rtlLanguages.includes(language) ? 'rtl' : 'ltr';
        document.documentElement.dir = dir;
    }

    componentWillUnmount() {
        this.stopPolling();
    }

    componentDidUpdate(oldProps) {
        if (this.props.tracking?.data?.orderStatus) {
            if (includes(FinalStatuses, this.props.tracking.data.orderStatus)) {
                this.stopPolling();
            }
        }
        if (this.props.tracking?.error === NOT_FOUND_ERR) {
            this.stopPolling();
        }
    }

    startPolling() {
        if (!this.interval) {
            this.props.thunkLoadTracking(this.state.token, this.state.locale);
            this.interval = setInterval(() => {
                this.props.thunkLoadTracking(this.state.token, this.state.locale);
            }, 5 * 1000);
        }
    }

    stopPolling() {
        if (this.interval) {
            clearInterval(this.interval);
        }
    }

    onLegalApprove() {
        this.props.thunkPushEvent(this.state.token, EventType.EVENT_TYPE_USER_AGREEMENT_ACCEPTED);
        this.props.cookies.set(this.state.token, true, { maxAge: 60 * 60 * 24 * 2 });
        this.setState({ legalApproved: true });
        this.startPolling();
    }

    selectComponent() {
        if (!this.state.legalApproved) {
            return <Legal onApproveClick={() => this.onLegalApprove()} />;
        }

        if (this.props.tracking.error && !this.props.tracking.data) {
            return <Completed />;
        }

        if (!this.props.tracking.data) {
            return <Loading />;
        }

        return (
            <div>
                <TrackingWrapper token={this.state.token} ride={this.props.tracking.data} />
            </div>
        );
    }

    render() {
        if (rtlLanguages.includes(this.state.locale)) {
            return <StyleSheetManager stylisPlugins={[rtlPlugin]}>{this.selectComponent()}</StyleSheetManager>;
        }
        return this.selectComponent();
    }
}

const mapStateToProps = (state: any, ownProps) => ({
    tracking: state.tracking,
    cookies: ownProps.cookies,
});

export default withTranslation()(
    withCookies(connect(mapStateToProps, { thunkLoadTracking, thunkPushEvent })(Tracking))
);
